window.Y = {
    Api: ":",
    Time: {
        getTempYWT: Date.now()
    },
    User: {
        username: "",
        email: ""
    },
    Menu: "",
    Tool: {},
    Footer: {},
    RegExp: {
        ywt: /^[0-9a-zA-Z+/=]+\.[0-9a-fA-F]+$/
    },
    Convert: {
        status: { 0: "正常", 1: "禁用" },
        room_status: { 0: "正常", 1: "一人", 2: "两人", 3: "游戏中" },
        role: { 0: "玩家", 1: "代理", 2: "管理员", 9: "超级管理员" },
        result: { 0: "失败", 1: "胜利" }
    },
    GetTime: function(timestamp) {
        var dt = new Date();
        if (timestamp) dt = new Date(timestamp);
        var y = dt.getFullYear();
        var m = dt.getMonth() + 1;
        var d = dt.getDate();
        var h = dt.getHours();
        var f = dt.getMinutes();
        var s = dt.getSeconds();
        m = m < 10 ? "0" + m : m;
        d = d < 10 ? "0" + d : d;
        h = h < 10 ? "0" + h : h;
        f = f < 10 ? "0" + f : f;
        s = s < 10 ? "0" + s : s;
        return y + "-" + m + "-" + d + " " + h + ":" + f + ":" + s;
    },
    JSON: {
        parse: function(str) {
            try {
                return JSON.parse(str);
            } catch (err) {
                return { code: "ko", msg: "格式错误" };
            }
        },
        stringify: function(obj) {
            try {
                return JSON.stringify(obj);
            } catch (err) {
                return { code: "ko", msg: "格式错误" };
            }
        }
    },
    GetLocationParams: function() {
        var search = location.search;
        var searchArray = search.split("?");
        if (searchArray.length < 2) return {};
        var paramsString = searchArray[1];
        var paramsArray = paramsString.split("&");
        var paramsHash = {};
        paramsArray.forEach(function(item) {
            var group = item.split("=");
            if (group.length < 2) {
                paramsHash[group[0]] = "";
            } else {
                paramsHash[group[0]] = group[1];
            }
        });
        return paramsHash;
    },
    CheckIsLogin: function(that) {
        if (!Y.Local.get("private_token")) {
            location.href = "./login.html";
            return false;
        } else {
            that.isLogin = true;
            return true;
        }
    },
    // 循环执行队列
    LoopQueue: [],
    Axios: axios,
    Local: store.namespace("pdk").session
};
